import React, { Fragment, useEffect, useState } from "react"
import { compose } from "ramda"
import { connect } from "react-redux"
import * as moment from "moment"
import PropTypes from "prop-types"
import classnames from "classnames"
import _isEmpty from "lodash/isEmpty"
import _isNil from "lodash/isNil"

import DefaultTitle from "shared/components/DefaultTitle"
import EmptyState from "shared/components/EmptyState"
import WrapperSkeleton from "../../components/WrapperSkeleton"
import Typograph from "../../components/Typograph"
import Button from "shared/components/Button/Button"
import ModernModal from "shared/components/ModernModal"

import styles from "./styles.css"

import { preSchedule, preScheduleWindows } from "services/state/actions"
import { formatPreSchedule } from "../AddTicket/utils"

import iconError from "../../assets/svg/erro-desbloqueio.svg"

const Schedule = ({ preSchedule, preScheduleWindows }) => {
  const [rowSelected, setRowSelected] = useState({})
  const [scheduleWindowsData, setScheduleWindowsData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [openModalError, setOpenModalError] = useState(false)

  const withoutSchedule =
    _isEmpty(scheduleWindowsData) || _isNil(scheduleWindowsData)

  useEffect(() => {
    fetchData()
  }, [])

  const isSelected = (index) => rowSelected.index === index

  const getIdParam = () => {
    const queryParamList = window.location.pathname.split("/")
    const queryIdIndex =
      queryParamList.findIndex((query) => query === "schedule") + 1

    return queryParamList[queryIdIndex]
  }

  const handleSelectRow = (data, index) => {
    if (isSelected(index)) {
      return setRowSelected({})
    }
    return setRowSelected({ ...data, index })
  }

  const handleAgendar = async () => {
    if (Object.keys(rowSelected).length === 0) {
      console.warn("No row selected.")
      return
    }
    setIsLoading(true)

    const paramId = getIdParam()

    const dataForPreSchedule = formatPreSchedule({
      serviceOrderSomId: paramId,
      schedulingDate: moment(rowSelected.date).unix(),
      timeSlot: rowSelected.timeSlot
    })

    const response = await preSchedule(dataForPreSchedule)

    const hasError = response.type === "PRE_SCHEDULE_FAIL"
    setIsLoading(false)
    setOpenModalError(hasError)
  }

  const fetchData = async () => {
    const orderId = getIdParam()

    if (orderId) {
      try {
        const result = await preScheduleWindows({
          orderId
        })

        const filteredData = result.payload.data.filter(
          (item) => item.workSkill !== undefined
        )

        setScheduleWindowsData(filteredData)
        setIsLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error)
        setIsLoading(false)
      }
    }
  }

  return (
    <Fragment>
      <DefaultTitle>Portal de agendamentos</DefaultTitle>

      <WrapperSkeleton path="schedule" isChildrenReady={!isLoading}>
        {!isLoading && !withoutSchedule && (
          <Fragment>
            <div className={styles.tableContainerClass}>
              <table className={styles.tableClass}>
                <thead className={styles.theadClass}>
                  <tr>
                    <th>Horário</th>
                    <th>Data</th>
                  </tr>
                </thead>

                <tbody className={styles.tbodyClass}>
                  {scheduleWindowsData.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => handleSelectRow(item, index)}
                      className={classnames(
                        isSelected(index) ? styles.isSelected : ""
                      )}
                    >
                      <td>{item.timeSlot}</td>
                      <td>{moment(item.date).format("DD/MM/YYYY")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={styles.buttonContainer}>
              <Button
                width="small"
                onClick={handleAgendar}
                disabled={_isEmpty(rowSelected)}
              >
                Agendar
              </Button>
            </div>
          </Fragment>
        )}
        {!isLoading && withoutSchedule && (
          <EmptyState
            title="Ops!"
            description="Não foi possível carregar a lista de agendamentos."
            icon={iconError}
          />
        )}
      </WrapperSkeleton>

      <ModernModal
        isOpen={openModalError}
        onClose={() => setOpenModalError(false)}
        onConfirm={() => setOpenModalError(false)}
        confirmButtonText="Concluir"
        widthButton="large"
        removeButton
        positionFooter="center"
      >
        <div className={styles.modalErrorClass}>
          <img src={iconError} alt="Icon error" />
          <Typograph
            htmlTag="h1"
            size="medium"
            color="outer_space"
            weight="bold"
          >
            Ops! Ocorreu um erro!
          </Typograph>
          <Typograph
            htmlTag="p"
            size="small"
            color="outer_space"
            weight="regular"
          >
            Tente novamente mais tarde!
          </Typograph>
        </div>
      </ModernModal>
    </Fragment>
  )
}

Schedule.propTypes = {
  preSchedule: PropTypes.func,
  preScheduleWindows: PropTypes.func
}

const mapStateToProps = ({ customer, products, myCalls }) => ({
  customer,
  products,
  myCalls
})

const enhance = compose(
  connect(mapStateToProps, {
    preSchedule,
    preScheduleWindows
  })
)

export default enhance(Schedule)



// WEBPACK FOOTER //
// ./src/scenes/Schedule/index.js